// frontend/packages/business-console/src/components/build-interview/AnswerField.jsx
//
// Restyled freeform answer field for the build interview (Website Builder
// Redesign, Phase 1): a controlled textarea with a focus ring, a live char
// counter, and a gradient "Save & continue" action. Controlled so the example
// chips (rendered by QuestionCard) can append scaffolds into it.
//
// AI-assist / attach affordances from the mock are deferred (scoping decision);
// not rendered here in P1.

import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import useTokens from '../primitives/useTokens';

const MAX = 6000;

export default function AnswerField({
  value,
  onChange,
  busy = false,
  placeholder = 'Type your answer here',
  inputRef,
}) {
  const t = useTokens();
  const localRef = useRef(null);
  const ref = inputRef || localRef;
  const len = (value || '').length;
  const over = len > MAX;

  return (
    <Box>
      <Box
        sx={{
          border: `2px solid ${t.grayBorder}`,
          borderRadius: '14px',
          background: t.card,
          transition: 'border-color .15s ease, box-shadow .15s ease',
          '&:focus-within': {
            borderColor: t.blue,
            boxShadow: '0 0 0 4px rgba(37,99,235,.1)',
          },
          p: '12px 14px',
        }}
      >
        <Box
          component="textarea"
          ref={ref}
          rows={5}
          maxLength={MAX}
          disabled={busy}
          placeholder={placeholder}
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          sx={{
            width: '100%',
            border: 'none',
            outline: 'none',
            resize: 'vertical',
            font: 'inherit',
            fontSize: 13.5,
            lineHeight: 1.6,
            color: t.text,
            background: 'transparent',
            display: 'block',
            '&::placeholder': { color: t.faint },
          }}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 0.5,
          }}
        >
          <Typography
            sx={{
              fontSize: 11,
              color: over ? t.red : t.faint,
              fontWeight: over ? 700 : 400,
            }}
          >
            {len} / {MAX}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
